const { DateTime } = require('luxon');
const { isNil } = require('ramda');

export function isMorning(dateTime) {
  return dateTime.toUTC().hour < 6;
}

export function toLocaleTH(dateTime) {
  const isBuddhistCalendar = dateTime.year > 2500;

  if (isBuddhistCalendar) {
    return dateTime.setZone("utc+7").setLocale("th");
  }

  return dateTime
    .setZone("utc+7")
    .setLocale("th")
    .reconfigure({ outputCalendar: "buddhist" });
}

export function getAppointmentTimeText(dateTime) {
  return isMorning(dateTime)
    ? "ช่วงเช้า (09:00 - 12:00 น.)"
    : "ช่วงบ่าย (13:00 - 16:00 น.)";
}

export function getDurationAppointmentTimeText(dateTimeStart, dateTimeEnd) {
  const ISOdateTime = dateTimeStart
    ? DateTime.fromISO(dateTimeStart)
    : null;

  const ISOdateTimeEnd = dateTimeEnd
    ? DateTime.fromISO(dateTimeEnd)
    : null;

  const dateTimeStartFormat = ISOdateTime
    ? toLocaleTH(ISOdateTime).toFormat("HH:mm")
    : null;
  const dateTimeStartEnd = ISOdateTimeEnd
    ? toLocaleTH(ISOdateTimeEnd).toFormat("HH:mm")
    : null;

  let time = ''
  if (dateTimeStartFormat && dateTimeStartEnd) {
    time = `(${dateTimeStartFormat} - ${dateTimeStartEnd} น.)`
  } else if (dateTimeStartFormat) {
    time = `(${dateTimeStartFormat} น.)`
  }

  return time
}

export function convertDateTimeToTimeText(dateTimeStart, format = "dd MMM yyyy HH:mm น.") {
  const ISOdateTime = dateTimeStart
    ? DateTime.fromISO(dateTimeStart)
    : null;

  return ISOdateTime
    ? toLocaleTH(ISOdateTime).toFormat(format)
    : '';
}

export function toOptionalDateTime(optionalISOString) {
  if (isNil(optionalISOString)) return undefined;

  return DateTime.fromISO(optionalISOString);
}

export function toOptionalISOString(optionalDateTime) {
  if (isNil(optionalDateTime)) return undefined;

  return optionalDateTime.toISO();
}

export function fromJSDateToOptionalISODate(OptionalDateTime) {
  const isoDate = OptionalDateTime
    ? DateTime.fromJSDate(OptionalDateTime).toUTC().toISO()
    : null;

  return isoDate;
}

export function formatOrFallbackToInput(date, format) {
  if (DateTime.fromISO(date).isValid) {
    return toLocaleTH(
      DateTime.fromISO(date)
    ).toFormat(format);
  } else {
    return date
  }
}


// WEBPACK FOOTER //
// ./src/lib/dateTime.js